import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    rejestr: [],
    zdarzenia: [], // przykład
}

const statusySlice = createSlice({
    name: 'statusy',
    initialState,
    reducers: {
        setStatusy(state, action) {
            state[action?.payload?.modul] = action.payload.statusy
        }
    }
})

export const {setStatusy} = statusySlice.actions

export default statusySlice.reducer